import L from 'leaflet';
import uniqueId from 'lodash/uniqueId';

function mapSearchResults(results) {
  return results.map(item => ({
    name: item.display_name,
    bounds: [
      L.latLng({
        lat: Number(item.boundingbox[0]),
        lng: Number(item.boundingbox[2]),
      }),
      L.latLng({
        lat: Number(item.boundingbox[1]),
        lng: Number(item.boundingbox[3]),
      }),
    ],
    icon: item.icon,
    geojson: item.geojson,
    position: L.latLng({ lat: item.lat, lng: item.lon }),
    id: item.place_id,
  }));
}

export function mapCoordinates(coords) {
  const position = L.latLng(coords);
  return {
    name: posToDMS(position),
    position,
    icon: 'globe',
    id: uniqueId('coords_'),
  };
}

function posToDMS(pos) {
  const lat = toDMS(pos.lat, 'NS');
  const lng = toDMS(pos.lng, 'EW');
  return `${lat} ${lng}`;
}

function toDMS(dd, dir) {
  const postfix = dd >= 0 ? dir[0] : dir[1];
  const [degrees, minsec] = split60(Math.abs(dd));
  const result = [degrees, '°'];
  if (minsec > 0) {
    const [minutes, seconds] = split60(minsec);
    result.push(minutes, "'");
    if (seconds > 0) {
      result.push(Math.floor(seconds), '"');
    }
  }
  result.push(postfix);
  return result.join('');
}

function split60(val) {
  const intPart = Math.floor(val);
  return [intPart, (val - intPart) * 60];
}

export default mapSearchResults;
